import styled from 'styled-components';
import MailboxOpenIcon from 'mdi-react/MailboxOpenIcon';

import { colors } from '@crm-framework/theme';

export const EmptyStateContent = styled.div.attrs({
  className: 'notifications__empty-state',
})`
  text-align: center;
`;

export const EmptyStateIcon = styled(MailboxOpenIcon)`
  color: ${colors.N8};
  margin-bottom: 10px;
`;

export const EmptyStateHeader = styled.h2`
  margin: 0 0 5px 0;
  color: ${colors.HEADING};
`;

export const EmptyStateDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${colors.DESCRIPTION};
`;
